import { render, staticRenderFns } from "./SwitchCompanySuccess.vue?vue&type=template&id=0362bba9"
import script from "./SwitchCompanySuccess.vue?vue&type=script&lang=js"
export * from "./SwitchCompanySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports